// extracted by mini-css-extract-plugin
export default {"delivery":"DeliveryPage_delivery__lzvTu","details":"DeliveryPage_details__yZlnQ","order":"DeliveryPage_order__zv9+I"};